import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { userRoleFormate } from "@/constant/userRole";

export default function WelcomeSection() {
  const [today, setDate] = useState(new Date());
  const userDetails = useSelector((state) => state.user?.userDetails);
  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="az-content-header  d-flex justify-content-end">
      <div className=" ">
        <div>
          <label className="tx-13">
            {moment(today).format("hh:mm A")} | {moment(today).format("DD MMMM yyyy")} |
            <span className="text-capitalize d-inline-block mx-1">{userRoleFormate[userDetails.role] || "Site User"}</span>
            Account
          </label>
        </div>
      </div>
    </div>
  );
}
